import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { validateEmail } from "../../utils/util";
import { searchUsers } from "../../services/users";
import { Login } from "../../actions/actions";
import PageSelector from '../../components/PageSelector';
import LoadingPage from "../../components/Loading";
import DropdownMenu from '../../components/DropdownMenu'

const limit = 20
function Page(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [isloading, setIsloading] = useState(false)


    const [searchParams, setSearchParams] = useSearchParams();
    const [totalItem, setTotalItem] = useState(1)
    const totalPage = Math.ceil(totalItem / limit) || 1
    const [data, setData] = useState([])
    const page = parseInt(searchParams.get('page')) || 1
    const filterLastname = searchParams.get('lastname')
    const filterFirstname = searchParams.get('firstname')
    const filterEmail = searchParams.get('email')
    const filterMobile = searchParams.get('mobile')
    const filterType = searchParams.get('type') || '全部'
    //
    const handleSearchLastname = (e) => { setSearchParams({ page: 1, lastname: e.target.value }) }
    const handleSearchFirstname = (e) => { setSearchParams({ page: 1, firstname: e.target.value }) }
    const handleSearchEmail = (e) => { setSearchParams({ page: 1, email: e.target.value }) }
    const handleSearchMobile = (e) => { setSearchParams({ page: 1, mobile: e.target.value }) }
    useEffect(() => {
        if (!props.token.isLogin) return
        const timer = setTimeout(fetchData, 500)
        const interval = setInterval(fetchData, 1000 * 30)
        return () => {
            clearTimeout(timer)
            clearInterval(interval)
        }
    }, [searchParams, props.token])
    async function fetchData() {
        // formatDataForChart()
        const filter = { type: 'user', status: 'active' }

        if (filterLastname) filter['data.lastname'] = { "$regex": filterLastname, "$options": 'i' }
        if (filterFirstname) filter['data.firstname'] = { "$regex": filterFirstname, "$options": 'i' }
        if (filterEmail) filter['email'] = { "$regex": filterEmail, "$options": 'i' }
        if (filterMobile) filter['mobile'] = { "$regex": filterMobile, "$options": 'i' }
        const res = await searchUsers(props.token.token, filter, { limit, skip: limit * (page - 1), sort: { _id: -1 } })
        console.log(res)
        if (res.errno) return
        setTotalItem(res.count)
        setData(res.result)

        const toPage = Math.ceil(res.count / limit) || 1
        if (page > toPage) handleParamChange('page', 1)
    }
    const handleSelectPage = (p) => () => {
        if (p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }
    function handleParamChange(key, val) {
        searchParams.delete(key)
        if (val !== '') searchParams.set(key, val)
        setSearchParams(searchParams)
    }
    function selectFilter(item, index) {
        searchParams.delete('type')
        searchParams.set('type', item)
        setSearchParams(searchParams)
    }

    return (
        <div className="w-full h-full flex flex-col items-center justify-start bg-[#ddd] overflow-hidden py-[16px]">
            <div className="w-full flex flex-row gap-[16px] px-[16px] py-[24px] relative flex-wrap items-center">
                <div className="gap-[8px] flex flex-row items-center justify-start z-[2] px-[12px] py-[2px] border-[1px] border-[#6E604C] rounded-[99px]">
                    <SearchSvg />
                    <input onChange={handleSearchLastname} placeholder="姓氏搜尋" className="bg-[transparent] w-[130px] border-none" />
                </div>
                <div className="gap-[8px] flex flex-row items-center justify-start z-[2] px-[12px] py-[2px] border-[1px] border-[#6E604C] rounded-[99px]">
                    <SearchSvg />
                    <input onChange={handleSearchFirstname} placeholder="名字搜尋" className="bg-[transparent] w-[130px] border-none" />
                </div>
                <div className="gap-[8px] flex flex-row items-center justify-start z-[2] px-[12px] py-[2px] border-[1px] border-[#6E604C] rounded-[99px]">
                    <SearchSvg />
                    <input onChange={handleSearchEmail} placeholder="電子郵件搜尋" className="bg-[transparent] w-[130px] border-none" />
                </div>
                <div className="gap-[8px] flex flex-row items-center justify-start z-[2] px-[12px] py-[2px] border-[1px] border-[#6E604C] rounded-[99px]">
                    <SearchSvg />
                    <input onChange={handleSearchMobile} placeholder="電子電話搜尋" className="bg-[transparent] w-[130px] border-none" />
                </div>
                <div className="flex flex-row justify-end z-[2]">
                    <DropdownMenu value={filterType} select={selectFilter} options={['全部', '待批准', '已核准', '已拒絕']} />
                </div>
                <div className="flex-1 flex flex-row justify-end z-[2] gap-[12px]">
                    <div className="cursor-pointer hover:opacity-[.5]">
                        <AddMemberBtnSvg />
                    </div>
                    <div className="cursor-pointer  hover:opacity-[.5]">
                        <DeleteMemberSvg />
                    </div>
                </div>
                <div className="absolute w-full bottom-0 left-0 right-0 top-0" style={{ background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 69%, rgba(255, 255, 255, 0.6) 87.5%, #FFFFFF 100%)', zIndex: 1 }} />
            </div>
            <div className="flex-1 w-full flex flex-col p-[16px]" style={{ overflowY: 'auto' }}>
                {/*Header */}
                <div className="flex flex-row justify-betwen items-center w-full text-[12px] text-[#6E604C] font-[700] pb-[8px]" style={{ borderBottom: '2px solid #6E604C' }}>
                    <div className="flex-[2]">電郵地址(Email)</div>
                    <div className="flex-[2]">電話(Mobile)</div>
                    <div className="flex-1">性別(Gender)</div>
                    <div className="flex-1">姓(Surname)</div>
                    <div className="flex-1">名(Firstname)</div>
                    <div className="flex-[2]">公司/組織(Company)</div>
                    <div className="flex-[2]">頭銜(Position)</div>
                    <div className="w-[100px]" />
                </div>

                <div className="flex-1 w-full flex flex-col mt-[16px]">
                    {data?.map((item, index) =>
                        <div key={item?._id} className="flex flex-row justify-betwen items-center w-full text-[12px] text-[black] font-[400] py-[8px]" style={{ borderBottom: '.5px solid #fff' }}>
                            <div className="flex-[2]">{item?.email || ''}</div>
                            <div className="flex-[2]">{item?.mobile || ''}</div>
                            <div className="flex-1">{item?.data?.gender || ''}</div>
                            <div className="flex-1">{item?.data?.lastname || ''}</div>
                            <div className="flex-1">{item?.data?.firstname || ''}</div>
                            <div className="flex-[2]">{item?.data?.company || ''}</div>
                            <div className="flex-[2]">{item?.data?.position || ''}</div>
                            <div className="w-[100px] flex flex-row justify-end items-center gap-[8px]">
                                <div className="cursor-pointer hover:opacity-[.5]">
                                    <MoreOptionsButton />
                                </div>
                                <div className="cursor-pointer hover:opacity-[.5]">
                                    <DeleteIconSvg />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>


            <PageSelector page={page} total={totalItem} totalPage={totalPage} handleSelectPage={handleSelectPage} />

            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)




const ReloadSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={15}
        height={17}
        fill="none"
        {...props}
    >
        <path
            fill="#7A7A7A"
            d="M14.445 7.931a7.07 7.07 0 0 0-1.071-2.545 7.16 7.16 0 0 0-1.922-1.922 7.077 7.077 0 0 0-4-1.214V.667L4.31 3.039l3.144 2.373v-1.58a5.505 5.505 0 0 1 3.113.943 5.539 5.539 0 0 1 .82 8.507 5.557 5.557 0 0 1-2.797 1.508 5.641 5.641 0 0 1-2.231 0 5.538 5.538 0 0 1-4.42-5.424H.354c.001 1.418.425 2.804 1.218 3.98a7.192 7.192 0 0 0 1.92 1.92 7.078 7.078 0 0 0 3.98 1.217 7.128 7.128 0 0 0 5.902-3.139 7.08 7.08 0 0 0 1.215-3.978c0-.482-.049-.963-.145-1.435Z"
        />
    </svg>
)


const SearchSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        {...props}
    >
        <g clipPath="url(#a)">
            <path
                fill="#717171"
                d="M12.917 11.667h-.659l-.233-.225a5.393 5.393 0 0 0 1.308-3.525 5.417 5.417 0 1 0-5.416 5.416 5.393 5.393 0 0 0 3.525-1.308l.225.233v.659l4.166 4.158 1.242-1.242-4.158-4.166Zm-5 0a3.745 3.745 0 0 1-3.75-3.75 3.745 3.745 0 0 1 3.75-3.75 3.745 3.745 0 0 1 3.75 3.75 3.745 3.745 0 0 1-3.75 3.75Z"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
        </defs>
    </svg>
)


const AddMemberBtnSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={186}
        height={40}
        fill="none"
        {...props}
    >
        <rect width={186} height={40} fill="url(#aaaaa)" rx={7} />
        <g clipPath="url(#baaaa)">
            <path
                fill="#fff"
                d="M61.25 20.75h-4.5v4.5h-1.5v-4.5h-4.5v-1.5h4.5v-4.5h1.5v4.5h4.5v1.5Z"
            />
        </g>
        <path
            fill="#fff"
            d="m73.208 21.392 1.536.528c-.117.48-.267.965-.448 1.456-.181.48-.4.939-.656 1.376-.256.427-.56.81-.912 1.152l-1.408-1.12c.32-.267.597-.581.832-.944.245-.363.453-.752.624-1.168.181-.427.325-.853.432-1.28Zm3.808.864 1.408-.544c.277.533.523 1.11.736 1.728.213.619.363 1.157.448 1.616l-1.52.592a6.331 6.331 0 0 0-.208-1.056 14.175 14.175 0 0 0-.384-1.2c-.15-.416-.31-.795-.48-1.136Zm2-.336 1.488-.736c.32.395.624.827.912 1.296.288.47.544.933.768 1.392.235.448.41.859.528 1.232l-1.6.848a7.096 7.096 0 0 0-.48-1.264c-.213-.47-.464-.944-.752-1.424a13.26 13.26 0 0 0-.864-1.344ZM79 17.04c.245.437.555.859.928 1.264.384.405.816.768 1.296 1.088.48.32.987.576 1.52.768a8.816 8.816 0 0 0-.448.448c-.16.181-.315.368-.464.56a7.527 7.527 0 0 0-.352.528 7.948 7.948 0 0 1-1.664-1.024 9.762 9.762 0 0 1-1.392-1.424 11.082 11.082 0 0 1-1.056-1.68L79 17.04Zm-3.376-2.544 1.936.288c-.416 1.728-1.067 3.179-1.952 4.352-.885 1.163-2.032 2.085-3.44 2.768a4.622 4.622 0 0 0-.336-.48 6.223 6.223 0 0 0-.48-.576 3.775 3.775 0 0 0-.448-.464c1.301-.533 2.341-1.285 3.12-2.256.779-.981 1.312-2.192 1.6-3.632Zm4.64-2 1.44 1.52c-.64.181-1.339.336-2.096.464-.747.128-1.525.24-2.336.336-.8.085-1.605.15-2.416.192-.81.043-1.6.075-2.368.096a4.708 4.708 0 0 0-.208-.832 6.337 6.337 0 0 0-.288-.816 55.99 55.99 0 0 0 2.256-.112 67.47 67.47 0 0 0 2.24-.192c.736-.075 1.43-.165 2.08-.272.65-.107 1.216-.235 1.696-.384Zm-8.72 3.712H82.28v1.728H71.544v-1.728Zm3.648 3.6h1.76v5.712c0 .416-.043.747-.128.992-.085.256-.267.459-.544.608a2.755 2.755 0 0 1-.96.24c-.363.032-.8.048-1.312.048a5.36 5.36 0 0 0-.192-.864 7.145 7.145 0 0 0-.288-.848c.299.01.587.016.864.016h.544c.17 0 .256-.075.256-.224v-5.68Zm-6.992-5.92 1.072-1.392c.31.128.63.283.96.464.341.17.661.352.96.544.31.192.555.379.736.56L70.776 15.6c-.17-.192-.4-.39-.688-.592-.288-.203-.597-.4-.928-.592-.33-.203-.65-.379-.96-.528Zm-.752 4.352 1.056-1.424c.31.117.63.261.96.432.341.16.661.33.96.512.31.181.56.357.752.528L70.04 19.84a4.268 4.268 0 0 0-.704-.544 8.86 8.86 0 0 0-.944-.576 8.78 8.78 0 0 0-.944-.48Zm.32 7.968c.224-.416.464-.901.72-1.456a34.54 34.54 0 0 0 .784-1.76c.267-.63.517-1.253.752-1.872l1.536 1.072a60.775 60.775 0 0 1-.656 1.712 62.393 62.393 0 0 1-1.392 3.36l-1.744-1.056Zm25.04-2.064h4.096v1.84h-4.096v-1.84ZM83.8 15.28h5.856v1.872H83.8V15.28Zm8.144-1.04h5.824v12.752h-1.92V16.096h-2.064v11.008h-1.84V14.24Zm-2.752 1.04h1.856v.544c0 .139-.005.25-.016.336-.032 1.707-.07 3.163-.112 4.368a71.855 71.855 0 0 1-.128 2.944c-.043.768-.107 1.37-.192 1.808-.085.437-.192.747-.32.928-.181.267-.368.459-.56.576a2.1 2.1 0 0 1-.688.256c-.235.053-.523.08-.864.08-.341.01-.699.005-1.072-.016a4.73 4.73 0 0 0-.16-.976 3.637 3.637 0 0 0-.384-.944c.32.021.613.037.88.048.267.01.475.016.624.016a.672.672 0 0 0 .304-.064.643.643 0 0 0 .24-.24c.085-.117.16-.363.224-.736s.117-.917.16-1.632c.043-.715.08-1.632.112-2.752.032-1.13.064-2.507.096-4.128v-.416Zm-3.488-2.64h1.888c0 1.579-.027 3.088-.08 4.528a38.641 38.641 0 0 1-.32 4.032 16.06 16.06 0 0 1-.848 3.472 8.835 8.835 0 0 1-1.616 2.768 3.546 3.546 0 0 0-.384-.512 5.807 5.807 0 0 0-.512-.512 3.546 3.546 0 0 0-.512-.384c.501-.565.901-1.2 1.2-1.904.31-.715.544-1.493.704-2.336.17-.843.288-1.744.352-2.704.064-.97.101-1.995.112-3.072.01-1.088.016-2.213.016-3.376Zm17.328 5.6v2.016h7.904V18.24h-7.904Zm-1.6-1.2h11.2v4.384h-11.2V17.04Zm2.736-1.808h5.664v1.248h-5.664v-1.248Zm1.968 2.208h1.552v3.376h-1.552V17.44Zm.768-3.552c-.469.459-1.056.923-1.76 1.392-.704.47-1.467.907-2.288 1.312-.821.395-1.653.741-2.496 1.04a8.593 8.593 0 0 0-.448-.768 5.065 5.065 0 0 0-.56-.736 18.366 18.366 0 0 0 2.576-.992 15.813 15.813 0 0 0 2.304-1.312c.693-.48 1.259-.955 1.696-1.424h1.808a14.335 14.335 0 0 0 2.048 1.552c.757.47 1.547.875 2.368 1.216.832.33 1.659.603 2.48.816-.203.213-.4.47-.592.768-.192.299-.363.57-.512.816a22.07 22.07 0 0 1-1.76-.688 25.565 25.565 0 0 1-1.808-.88 22.758 22.758 0 0 1-1.68-1.024 12.911 12.911 0 0 1-1.376-1.088Zm-3.312 4.688 1.312-.352c.149.267.283.56.4.88.117.32.197.597.24.832l-1.392.416a5.049 5.049 0 0 0-.208-.848 7.752 7.752 0 0 0-.352-.928Zm5.28-.416 1.6.384c-.181.341-.352.672-.512.992-.149.32-.293.592-.432.816l-1.296-.368c.107-.256.224-.56.352-.912.139-.352.235-.656.288-.912Zm-6.56 3.792h9.472v5.424H109.8V23.2h-5.6v4.24h-1.888v-5.488Zm1.072 1.888h7.232v1.248h-7.232V23.84Zm.016 1.92h7.216v1.248H103.4V25.76Zm16.384-11.36v1.04h6.496V14.4h-6.496Zm-1.936-1.488h10.464v4.016h-10.464v-4.016Zm1.184 7.824v.688h7.856v-.688h-7.856Zm0 1.904v.688h7.856v-.688h-7.856Zm0-3.792v.672h7.856v-.672h-7.856Zm-1.904-1.312h11.76v7.104h-11.76v-7.104Zm3.104 6.768 1.696 1.2c-.427.256-.928.507-1.504.752-.565.245-1.152.47-1.76.672-.597.213-1.168.384-1.712.512a10.782 10.782 0 0 0-.704-.704c-.277-.267-.528-.49-.752-.672a20.497 20.497 0 0 0 1.744-.48c.597-.192 1.163-.4 1.696-.624a8.548 8.548 0 0 0 1.296-.656Zm3.504 1.296 1.696-1.2c.565.139 1.163.315 1.792.528.629.203 1.237.41 1.824.624.597.203 1.115.39 1.552.56l-1.696 1.36a29.158 29.158 0 0 0-1.52-.64 45.62 45.62 0 0 0-1.84-.656 48.959 48.959 0 0 0-1.808-.576Z"
        />
        <defs>
            <linearGradient
                id="aaaaa"
                x1={93}
                x2={93}
                y1={0}
                y2={40}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#8C866B" />
                <stop offset={1} stopColor="#8C866B" stopOpacity={0.2} />
            </linearGradient>
            <clipPath id="baaaa">
                <path fill="#fff" d="M47 11h18v18H47z" />
            </clipPath>
        </defs>
    </svg>
)

const DeleteMemberSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={122}
        height={40}
        fill="none"
        {...props}
    >
        <rect width={122} height={40} fill="url(#afgfg)" rx={7} />
        <path
            fill="#fff"
            d="M39.336 14.352H41v9.056h-1.664v-9.056Zm2.832-1.616h1.744v12.512c0 .501-.053.885-.16 1.152-.107.267-.304.48-.592.64-.277.15-.645.245-1.104.288-.448.053-.976.08-1.584.08a4.258 4.258 0 0 0-.208-.928 5.669 5.669 0 0 0-.352-.928c.416.01.805.021 1.168.032h.752a.483.483 0 0 0 .256-.08c.053-.043.08-.128.08-.256V12.736Zm-5.568.32h1.648v12.56c0 .32-.037.603-.112.848a1.074 1.074 0 0 1-.384.608c-.192.139-.405.23-.64.272a3.295 3.295 0 0 1-.832.064 3.383 3.383 0 0 0-.128-.528 6.644 6.644 0 0 0-.192-.608 2.303 2.303 0 0 0-.224-.512c.15.01.288.016.416.016s.219-.005.272-.016c.117 0 .176-.064.176-.192V13.056Zm-6.224 0h7.104v1.664h-5.536v12.72h-1.568V13.056Zm-.912 5.728h9.6v1.744h-9.6v-1.744Zm3.184-5.056h1.232v13.376h-1.232V13.728Zm1.968 0h1.216v13.344h-1.216V13.728Zm17.776 3.296h6.24v1.584h-6.24v-1.584Zm-.96 3.04H59.8v1.616h-8.368v-1.616Zm4.016-5.936c-.288.47-.656.955-1.104 1.456a14.31 14.31 0 0 1-1.456 1.44c-.523.459-1.072.859-1.648 1.2a5.071 5.071 0 0 0-.432-.8 6.132 6.132 0 0 0-.512-.736 8.84 8.84 0 0 0 1.68-1.2c.544-.48 1.04-.987 1.488-1.52.448-.533.81-1.045 1.088-1.536h1.68c.384.555.821 1.093 1.312 1.616.49.523 1.008 1.003 1.552 1.44.555.437 1.104.79 1.648 1.056-.17.213-.352.475-.544.784a7.917 7.917 0 0 0-.48.848 12.739 12.739 0 0 1-1.6-1.136 17.34 17.34 0 0 1-1.488-1.44 16.281 16.281 0 0 1-1.184-1.472Zm-.864 3.728h1.808v7.6c0 .427-.043.768-.128 1.024-.085.267-.267.475-.544.624-.256.139-.565.23-.928.272a10.95 10.95 0 0 1-1.264.064 6.397 6.397 0 0 0-.24-.896 6.446 6.446 0 0 0-.368-.88c.31.01.597.016.864.016h.544c.096-.01.16-.032.192-.064.043-.032.064-.09.064-.176v-7.584Zm-2.544 4.432 1.68.4a11.333 11.333 0 0 1-1.008 2.16c-.416.693-.853 1.27-1.312 1.728a5.399 5.399 0 0 0-.4-.352c-.16-.139-.325-.277-.496-.416a3.053 3.053 0 0 0-.464-.32 6.324 6.324 0 0 0 1.168-1.44c.352-.565.63-1.152.832-1.76Zm4.88.608 1.472-.688c.277.363.55.752.816 1.168.277.416.523.832.736 1.248.224.405.39.773.496 1.104l-1.584.784a5.708 5.708 0 0 0-.448-1.104 26.195 26.195 0 0 0-.704-1.28 14.464 14.464 0 0 0-.784-1.232Zm-10.784-9.808h3.776v1.728h-2.096V27.44h-1.68V13.088Zm3.2 0h.304l.272-.064 1.248.72c-.128.448-.272.933-.432 1.456-.16.523-.325 1.035-.496 1.536-.16.501-.315.96-.464 1.376.49.608.81 1.184.96 1.728.15.544.224 1.05.224 1.52 0 .512-.059.939-.176 1.28-.107.341-.288.603-.544.784a1.801 1.801 0 0 1-.432.208c-.15.053-.31.096-.48.128-.299.032-.65.043-1.056.032a4.67 4.67 0 0 0-.128-.816 2.712 2.712 0 0 0-.288-.816c.15.01.277.016.384.016h.32c.192-.01.341-.059.448-.144a.555.555 0 0 0 .192-.336c.043-.16.064-.352.064-.576 0-.373-.075-.8-.224-1.28-.139-.48-.432-.987-.88-1.52.107-.363.213-.757.32-1.184.117-.437.23-.875.336-1.312.117-.437.219-.843.304-1.216.096-.384.17-.704.224-.96v-.56Zm15.696 5.152v2.016h7.904V18.24h-7.904Zm-1.6-1.2h11.2v4.384h-11.2V17.04Zm2.736-1.808h5.664v1.248h-5.664v-1.248Zm1.968 2.208h1.552v3.376h-1.552V17.44Zm.768-3.552c-.47.459-1.056.923-1.76 1.392-.704.47-1.467.907-2.288 1.312-.821.395-1.653.741-2.496 1.04a8.52 8.52 0 0 0-.448-.768 5.065 5.065 0 0 0-.56-.736 18.351 18.351 0 0 0 2.576-.992c.843-.395 1.61-.832 2.304-1.312.693-.48 1.259-.955 1.696-1.424h1.808a14.335 14.335 0 0 0 2.048 1.552c.757.47 1.547.875 2.368 1.216.832.33 1.659.603 2.48.816-.203.213-.4.47-.592.768-.192.299-.363.57-.512.816a22.026 22.026 0 0 1-1.76-.688c-.608-.267-1.21-.56-1.808-.88a22.633 22.633 0 0 1-1.68-1.024 12.911 12.911 0 0 1-1.376-1.088Zm-3.312 4.688 1.312-.352c.15.267.283.56.4.88.117.32.197.597.24.832l-1.392.416a5.078 5.078 0 0 0-.208-.848 7.702 7.702 0 0 0-.352-.928Zm5.28-.416 1.6.384c-.181.341-.352.672-.512.992-.15.32-.293.592-.432.816l-1.296-.368c.107-.256.224-.56.352-.912.139-.352.235-.656.288-.912Zm-6.56 3.792h9.472v5.424H71.8V23.2h-5.6v4.24h-1.888v-5.488Zm1.072 1.888h7.232v1.248h-7.232V23.84Zm.016 1.92h7.216v1.248H65.4V25.76ZM81.784 14.4v1.04h6.496V14.4h-6.496Zm-1.936-1.488h10.464v4.016H79.848v-4.016Zm1.184 7.824v.688h7.856v-.688h-7.856Zm0 1.904v.688h7.856v-.688h-7.856Zm0-3.792v.672h7.856v-.672h-7.856Zm-1.904-1.312h11.76v7.104h-11.76v-7.104Zm3.104 6.768 1.696 1.2a12.32 12.32 0 0 1-1.504.752c-.565.245-1.152.47-1.76.672-.597.213-1.168.384-1.712.512a10.858 10.858 0 0 0-.704-.704c-.277-.267-.528-.49-.752-.672a20.497 20.497 0 0 0 1.744-.48c.597-.192 1.163-.4 1.696-.624a8.52 8.52 0 0 0 1.296-.656Zm3.504 1.296 1.696-1.2c.565.139 1.163.315 1.792.528.63.203 1.237.41 1.824.624.597.203 1.115.39 1.552.56l-1.696 1.36a29.048 29.048 0 0 0-1.52-.64c-.587-.224-1.2-.443-1.84-.656a49.141 49.141 0 0 0-1.808-.576Z"
        />
        <defs>
            <linearGradient
                id="afgfg"
                x1={61}
                x2={61}
                y1={0}
                y2={40}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#8C706B" />
                <stop offset={1} stopColor="#8C706B" stopOpacity={0.2} />
            </linearGradient>
        </defs>
    </svg>
)


const MoreOptionsButton = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        fill="none"
        {...props}
    >
        <rect
            width={31}
            height={31}
            x={0.5}
            y={0.5}
            fill="#fff"
            fillOpacity={0.5}
            rx={4.5}
        />
        <rect width={31} height={31} x={0.5} y={0.5} stroke="#fff" rx={4.5} />
        <g clipPath="url(#awewe)">
            <path
                fill="#9B8C6F"
                d="M12 14.666c-.733 0-1.333.6-1.333 1.334 0 .733.6 1.333 1.333 1.333s1.333-.6 1.333-1.333-.6-1.334-1.333-1.334Zm8 0c-.733 0-1.333.6-1.333 1.334 0 .733.6 1.333 1.333 1.333s1.333-.6 1.333-1.333-.6-1.334-1.333-1.334Zm-4 0c-.733 0-1.333.6-1.333 1.334 0 .733.6 1.333 1.333 1.333s1.333-.6 1.333-1.333-.6-1.334-1.333-1.334Z"
            />
        </g>
        <defs>
            <clipPath id="awewe">
                <path fill="#fff" d="M8 8h16v16H8z" />
            </clipPath>
        </defs>
    </svg>
)
const DeleteIconSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        fill="none"
        {...props}
    >
        <rect width={32} height={32} fill="#E2E2E2" rx={5} />
        <g clipPath="url(#adele)">
            <path
                fill="#7D7D7D"
                d="M12 20.667C12 21.4 12.6 22 13.333 22h5.334C19.4 22 20 21.4 20 20.667v-8h-8v8ZM13.333 14h5.334v6.667h-5.334V14Zm5-3.333L17.667 10h-3.334l-.666.667h-2.334V12h9.334v-1.333h-2.334Z"
            />
        </g>
        <defs>
            <clipPath id="adele">
                <path fill="#fff" d="M8 8h16v16H8z" />
            </clipPath>
        </defs>
    </svg>
)